import {Tokens, Template, initDatetimeTokens} from '@inseinc/rgs-client-common'
var $ = require( "jquery" );

if(!window.VIRGO){
    window.VIRGO = {};
}

var qsParams, infobar, gameFrame, tokenFunctions = {}, remoteFunctions = {}, model = {}, fullscreenDiv, initFn, handleMessageFn;
var infobarState = {
    position:"bottom",
    visible:false,
    baseSize: 24,
    baseUnit: "px",
    scale: 1,
    nativeGameWidth:1920,
    nativeGameHeight:1080
};

console.log("Tokens",Tokens);
console.log("initDatetimeTokens",initDatetimeTokens);

initDatetimeTokens();

function calculateSize(relSize){
    return (infobarState.baseSize * infobarState.scale * relSize) + infobarState.baseUnit
}

Tokens.addTokenFunction({
    name: "size",
    fn: calculateSize,
    parseArgs: function(str){
        return [parseFloat(str)];
    }
});

function getUrlParams()
{
    var params = [], item, elements, i;
    elements = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(i = 0; i < elements.length; i+=1)
    {
        item = elements[i].split('=');
        params[decodeURIComponent(item[0])] = decodeURIComponent(item[1]);
    }
    return params;
}
qsParams = getUrlParams();

function iframeResize(){
    var topHeight, $game;
    if(!infobar || !gameFrame){
        return;
    }
    $game = $(gameFrame);
    topHeight = infobar.offsetHeight;
    $game.css("height",(document.documentElement.clientHeight - topHeight)+"px");
}

VIRGO.relayPostMessage = function(event){
    if(window === window.top){
        return;
    }
    if(event.source == gameFrame.contentWindow){
        window.parent.postMessage(event.data,"*");
    }else if(event.source == window.parent){
        gameFrame.contentWindow.postMessage(event.data,"*");
    }
}

VIRGO.handleInfobarMessage = function(event){
    if(typeof event.data === "object" && event.data.inggTarget === "infobar"){
        remoteFunctions[event.data.method].apply(null,event.data.args);
        return true;
    }
    return false;
}

function handleMessageImpl(event){
    if(VIRGO.handleInfobarMessage(event)){
        return
    }
    VIRGO.relayPostMessage(event);
}

function handleMessage(event){
    if(handleMessageFn){
        handleMessageFn(event,handleMessageImpl);
    }else{
        handleMessageImpl(event);
    }
}

function textResize(){
    let baseSize = infobarState.baseSize;
    let _nativeGameWidth = infobarState.nativeGameWidth;
    let _nativeGameHeight = infobarState.nativeGameHeight;
    let _innerWidth = $(window).width(); // get window width
    let _innerHeight = window.innerHeight; // get window height - inner height to take into account ios bars

    let _nativeGameOrientation = _nativeGameWidth > _nativeGameHeight ? "landscape" : "portrait";
    let _isLandscape = _innerWidth > _innerHeight;
    let _isPortrait = !_isLandscape;
    let _nativeLandscapeScreenRatio = _nativeGameWidth / _nativeGameHeight;
    let _nativePortraitScreenRatio = _nativeGameHeight / _nativeGameWidth;
    let _currentScreenRatio = _innerWidth / _innerHeight;

    var _screenDivScale;


   if ( ( _nativeGameOrientation === 'landscape' && _isLandscape ) || ( _nativeGameOrientation === 'portrait' && _isPortrait ) ) {
      if ( _currentScreenRatio < _nativeLandscapeScreenRatio ) {
         _screenDivScale = Math.round( _innerWidth ) / _nativeGameWidth;
      } else {
         _screenDivScale = Math.round( _innerHeight ) / _nativeGameHeight;
      }
   } else {
      if ( _currentScreenRatio < _nativePortraitScreenRatio ) {
         _screenDivScale = Math.round( _innerWidth ) / _nativeGameHeight;
      } else {
         _screenDivScale = Math.round( _innerHeight ) / _nativeGameWidth;
      }
   }

   infobarState.scale = _screenDivScale;

   $(document.body).css('fontSize', (baseSize * _screenDivScale) + infobarState.baseUnit);
}

function resize(){
    textResize();
    setTimeout( iframeResize, 300 );

    if(fullscreenDiv){
        fullscreenDiv.style.height = window.innerHeight + "px";
    }
}

function setInfobarPosition(position){
    infobarState.position = position;
    if(!gameFrame){
        return;
    }
    infobar.parentNode.removeChild(infobar);
    if(infobarState.position === "top"){
        document.body.insertBefore(infobar,gameFrame);
    }else{
        document.body.appendChild(infobar);
    }
}
remoteFunctions.setPosition = setInfobarPosition;

function getToken(name, tokens){
    for(let x=0; x<tokens.length; x++){
        let token = Tokens.parseToken(tokens[x]);
        if(token.name === name){
            return token;
        }
    }
    return null;
}

function render(force){
    if(!infobarState.view || !infobar){
        return;
    }
    infobarState.view.render(force);
}

function renderInfobarContent(content, isHtml){
    var hasTime;
    if(infobarState.view){
        infobarState.view.destroy();
        delete infobarState.view;
    }
    infobarState.infobarTemplate = new Template(content,"#{","}");
    infobarState.isHtml = isHtml;
    infobarState.view = Tokens.createView(infobarState.infobarTemplate,model,function(content){
        if(!infobar){
            return;
        }
        if(infobarState.isHtml){
            infobar.innerHTML = content;
        }else{
            infobar.innerText = content;
        }
        resize();

        // If size token is used in template it may be necessary to re-render
        if(getToken("size",infobarState.infobarTemplate.getTokens())){
            render(false);
        }
    });

    render();
}

function htmlEncode(str){
    return str.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
       return '&#'+i.charCodeAt(0)+';';
    });
}

function authorHtmlFromSimpleLine(text, encodeFn){
    let parts = text.split("|");
    if(!encodeFn){
        encodeFn = function(a){return a};
    }
    var innerHtml = "", outerHtml = "", colwidth = Math.floor(100/ parts.length), midcol = Math.floor(parts.length/2);
    outerHtml = "<div style=\"display: grid; grid-template-columns:";
    for(let x=0;x<parts.length;x++){
        innerHtml += "<div";
        if(x == parts.length-1 && parts.length>1){
            innerHtml += " style=\"text-align: right\"";
        }else if(parts.length === 1 || x > 0){
            innerHtml += " style=\"text-align: center\"";
        }
        innerHtml += ">"+encodeFn(parts[x])+"</div>";

        if(x === midcol){
            outerHtml += " auto";
        }else{
            outerHtml += " "+colwidth+"%";
        }
    }
    outerHtml += "\">"+innerHtml+"</div>";
    return outerHtml;
}

function setInforbarSimple(text, encodeFn){
    let lines = text.split("---");
    let html = "<div style=\"padding: #{size:0.5} #{size:3}\">";
    for(let x=0; x<lines.length; x++){
        html += authorHtmlFromSimpleLine(lines[x], encodeFn);
    }
    html += "</div>"

    renderInfobarContent(html,true);
}

function setInfobarContent(content, contentType){
    if("text" === contentType){
        renderInfobarContent(content,false);
    }else if("html" === contentType){
        renderInfobarContent(content,true);
    }else if("simple-text" === contentType){
        setInforbarSimple(content,htmlEncode);
    }else if("simple-html" === contentType){
        setInforbarSimple(content);
    }else{
        throw new Error("Unknown content type: "+contentType);
    }
}
remoteFunctions.setContent = setInfobarContent;

function setInfobarVisible(visible){
    if(visible === infobarState.visible){
        return;
    }
    infobarState.visible = visible;
    if(infobar){
        infobar.style.display = visible ? "" : "none";
        render(true);
    }
}
remoteFunctions.setVisible = setInfobarVisible;

function parseSize(value){
    if(typeof value === "string"){
        let pos = -1;
        for(let x=0;x<value.length;x++){
            if(value.charAt(x)<'0' || value.charAt(x)>'9'){
                pos = x;
                break;
            }
        }
        return pos != -1 ? {amount:parseFloat(value.substring(0,pos)),unit:value.substring(pos)} : {amount:parseFloat(value)};
    }else if(typeof value === "number"){
        return {amount:value};
    }
}

function setBaseSize(value){
    let size = parseSize(value);
    infobarState.baseSize = size.amount;
    if(size.unit){
        infobarState.baseUnit = size.unit;
    }
    render(true);
}
remoteFunctions.setBaseSize = setBaseSize;

function setNativeDimensions(dimensions){
    let pos = dimensions.indexOf("x");
    let width = parseInt(dimensions.substring(0,pos));
    let height = parseInt(dimensions.substring(pos+1));

    infobarState.nativeGameWidth = width;
    infobarState.nativeGameHeight = height;
    render(true);
}
remoteFunctions.setNativeDimensions = setNativeDimensions;

function relayMessage(message,targetOrigin){
    window.parent.postMessage(message,targetOrigin);
}
remoteFunctions.relayMessage = relayMessage;

function setTitle(title){
    var titleElem = document.querySelector("title");
    titleElem.innerText = title;
}
remoteFunctions.setTitle = setTitle;

function setModelValue(namespace,name,value){
    if(!model[namespace]){
        model[namespace] = {};
    }
    model[namespace][name] = value;
}
remoteFunctions.setModelValue = setModelValue;

function requestFullscreen(){
    if (screenfull.isEnabled && !screenfull.isFullscreen) {
        screenfull.request();
    }
}
remoteFunctions.requestFullscreen = requestFullscreen;

function isNotchedIPhone() {
    const isWindowsPhone = window.navigator.userAgent.indexOf( 'Windows Phone' ) >= 0;
    const isIphone = window.navigator.userAgent.indexOf( 'iPhone' ) >= 0;
    const isIpod = window.navigator.userAgent.indexOf( 'iPod' ) >= 0;
    if ( !isWindowsPhone && ( isIphone || isIpod ) ) {
        const min = Math.min( window.screen.width, window.screen.height );
        const max = Math.max( window.screen.width, window.screen.height );
        return ( max / min > 2 );
    }
    return false;
}

function getGameQueryString(){
    var qs, key, values, x;
    if(!VIRGO.postedParams){
        return window.location.search;
    }

    qs = "";
    for(key in VIRGO.postedParams){
        if(VIRGO.postedParams.hasOwnProperty(key)){
            values = VIRGO.postedParams[key];
            for(x=0;x<values.length;x++){
                if(qs.length===0){
                    qs += "?";
                }else{
                    qs += "&";
                }
                qs += encodeURIComponent(key) + "=" + encodeURIComponent(values[x]);
            }
        }
    }
    return qs;
}

function initImpl(){
    infobar = document.querySelector("#infobar");
    gameFrame = document.createElement("iframe");
    gameFrame.src = VIRGO.gameUrl + getGameQueryString();
    gameFrame.frameborder = 0;
    gameFrame.allow = "autoplay";
    if(infobarState.position === "top"){
        document.body.appendChild(gameFrame);
    }else{
        document.body.insertBefore(gameFrame,infobar);
    }
    if(!infobarState.visible){
        infobar.style.display = "none";
    }
    if(isNotchedIPhone()){
        infobar.style.paddingBottom = "11px";
    }
    resize(true);
    $(window).bind('resize', resize);
    setTimeout(resize,1000);
    window.addEventListener("message",handleMessage);
    window.requestFullscreen = requestFullscreen;
}

function init(){
    if(initFn){
        initFn(initImpl);
    }else{
        initImpl();
    }
}

VIRGO.setInitFunction = function(fn){
    initFn = fn;
};

VIRGO.setHandleMessageFunction = function(fn){
    handleMessageFn = fn;
}

VIRGO.jQuery = $;

window.addEventListener("load",init);
